import { Box, SimpleGrid } from "@chakra-ui/react";

import Ursers from "./Users/Index";
import tableDataComplex from "../default/variables/tableDataComplex";
import useUser from "hooks/use-user";
import LoadingComponent from "components/Main/Loading";
import * as crypto from "crypto-js";

export default function Overview() {
  const { loading } = useUser();

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="10px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        {loading ? (
          <>
            <LoadingComponent />
          </>
        ) : (
          <>
            <Ursers tableData={tableDataComplex} />
          </>
        )}
      </SimpleGrid>
    </Box>
  );
}
